/* Virute Studio — "Completa o look" (carrinho, carrinho vazio e ficha de produto).
   Fica num ficheiro à parte porque a gaveta é re-renderizada depois de adicionar.
   - Deslizar a foto com o dedo muda a cor (uma foto por cor); os círculos acompanham.
   - "+ Adicionar" junta a cor que está à vista. Se a peça tiver tamanhos, mostra-os e basta tocar num.
   A contagem de 24h está em assets/vs-v13.js. */
(function () {
  if (window.vsUpsellReady) return;
  window.vsUpsellReady = true;
  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Tira das recomendações tudo o que já está no carrinho. */
  function dedupe() {
    if (!document.querySelector('[data-vs-pid]')) return Promise.resolve();
    return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var ids = {};
        c.items.forEach(function (i) { ids[String(i.product_id)] = true; });
        document.querySelectorAll('[data-vs-pid]').forEach(function (card) {
          if (ids[card.getAttribute('data-vs-pid')]) card.remove();
        });
        document.querySelectorAll('[data-vs-group]').forEach(function (g) {
          if (!g.querySelector('[data-vs-pid]')) g.remove();
        });
      })
      .catch(function () {});
  }
  var timer;
  new MutationObserver(function (list) {
    var changed = list.some(function (m) {
      if (!m.addedNodes.length) return false;
      var t = m.target;
      return !(t && t.closest && t.closest('[data-vs-countdown], [data-left], .vs-upsell__timer, .vs-toast'));
    });
    if (!changed) return;
    clearTimeout(timer);
    timer = setTimeout(function () { dedupe(); init(); }, 300);
  }).observe(document.body, { childList: true, subtree: true });

  function data(card) {
    if (!card._vs) { try { card._vs = JSON.parse(card.getAttribute('data-vs-lk') || '{}'); } catch (e) { card._vs = { v: [] }; } }
    return card._vs;
  }
  function currentColor(card) {
    var on = card.querySelector('.vs-lk__slide.is-on') || card.querySelector('.vs-lk__slide');
    return on ? on.getAttribute('data-c') || '' : '';
  }
  function variantFor(card, size) {
    var d = data(card), c = currentColor(card);
    var list = (d.v || []).filter(function (v) {
      return (d.ci < 0 || v[1] === c) && (size == null || d.si < 0 || v[2] === size);
    });
    return list.filter(function (v) { return v[3]; })[0] || null;
  }
  /* Tamanhos esgotados na cor à vista ficam riscados. */
  function syncSizes(card) {
    var d = data(card), c = currentColor(card);
    card.querySelectorAll('[data-vs-size]').forEach(function (b) {
      var s = b.getAttribute('data-vs-size');
      var ok = (d.v || []).some(function (v) { return v[3] && (d.ci < 0 || v[1] === c) && v[2] === s; });
      b.disabled = !ok;
    });
  }
  function setIndex(card, i) {
    var slides = card.querySelectorAll('.vs-lk__slide');
    if (!slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    slides.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
    card.querySelectorAll('[data-vs-dot]').forEach(function (b, n) { b.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
    syncSizes(card);
  }

  /* Deslizar: a foto que fica à vista define a cor. */
  var scrollT;
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track || !track.matches || !track.matches('[data-vs-track]')) return;
    clearTimeout(scrollT);
    scrollT = setTimeout(function () {
      var card = track.closest('.vs-lk');
      if (card && track.clientWidth) setIndex(card, Math.round(track.scrollLeft / track.clientWidth));
    }, 60);
  }, true);

  function add(card, variantId) {
    var box = card.closest('[data-vs-upsell]');
    var onCartPage = box && box.getAttribute('data-cart-page') === '1';
    var addBtn = card.querySelector('[data-vs-add]');
    card.classList.add('is-busy');
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'A adicionar…'; }
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: 'cart-drawer-section' })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Erro');
        if (onCartPage) { window.location.reload(); return; }
        var html = res.j.sections && res.j.sections['cart-drawer-section'];
        var drawer = document.getElementById('cart-drawer');
        var cur = drawer && drawer.querySelector('.cart-drawer__inner');
        var fresh = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-drawer__inner') : null;
        if (!cur || !fresh) { window.location.href = rootUrl + 'cart'; return; }
        cur.replaceWith(fresh);
        if (!drawer.querySelector('dialog[open]') && typeof drawer.open === 'function') drawer.open();
        dedupe();
        return fetch(rootUrl + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('.cart-bubble__text-count, [data-cart-count], .header-actions__cart-count').forEach(function (el) { el.textContent = c.item_count; });
        });
      })
      .catch(function () {
        card.classList.remove('is-busy');
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = '+ Adicionar'; }
        window.location.href = rootUrl + 'cart';
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var dot = t.closest('[data-vs-dot]');
    if (dot && dot.closest('.vs-lk')) {
      e.preventDefault();
      var card = dot.closest('.vs-lk');
      var track = card.querySelector('[data-vs-track]');
      var i = +dot.getAttribute('data-vs-dot');
      if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      setIndex(card, i);
      return;
    }
    var size = t.closest('[data-vs-size]');
    if (size) {
      e.preventDefault();
      var c2 = size.closest('.vs-lk');
      var v = variantFor(c2, size.getAttribute('data-vs-size'));
      if (v) add(c2, v[0]);
      return;
    }
    var btn = t.closest('[data-vs-add]');
    if (!btn) return;
    e.preventDefault();
    var c3 = btn.closest('.vs-lk');
    if (!c3) return;
    if (btn.hasAttribute('data-need-size')) {
      var box = c3.querySelector('[data-vs-sizes]');
      if (box) { syncSizes(c3); box.hidden = false; c3.classList.add('is-picking'); }
      return;
    }
    var v3 = variantFor(c3, null);
    if (v3) add(c3, v3[0]);
  });

  function init() { document.querySelectorAll('.vs-lk').forEach(function (c) { if (!c.querySelector('.vs-lk__slide.is-on')) setIndex(c, 0); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();